import { createSlice } from '@reduxjs/toolkit';

const initialLoadingState = {
  loadingOpen: false,
  loadingTitle: 'Loading...',
  loadingMessage: 'Please wait.',
  queryInProcess: [],
  delayDuration: 0,
};

const loadingSlice = createSlice({
  name: 'loadingOpener',
  initialState: initialLoadingState,
  reducers: {
    showLoadingScreen(state, { payload }) {
      state.loadingOpen = payload;
    },
    updateLoadingTitle(state, { payload }) {
      state.loadingTitle = payload;
    },
    updateLoadingMessage(state, { payload }) {
      state.loadingMessage = payload;
    },
    addQuery(state, { payload }) {
      state.queryInProcess.push(payload);
    },
    removeQuery(state, { payload }) {
      const index = state.queryInProcess.indexOf(payload);
      if (index >= 0) {
        state.queryInProcess.splice(index, 1);
      } else {
        console.log(`query [${payload}] cannot be found in queue`);
      }
    },
    resetLoadingState: () => initialLoadingState,
    resetTimer: (state) => {
      state.delayDuration = initialLoadingState.delayDuration;
    },
  },
});

export const {
  addQuery,
  removeQuery,
  showLoadingScreen,
  updateLoadingTitle,
  updateLoadingMessage,
  resetLoadingState,
  resetTimer,
} = loadingSlice.actions;
export default loadingSlice.reducer;
